module.exports = __webpack_public_path__ + "static/icon_logo_white-96b4e3de82ee6694029cbe5a9b1b9c13.png";